import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AUTH_API_CONFIG } from './auth-config.token';
import { LoginCredentials, LoginV2Request, LoginV2Response } from './auth.types';

/**
 * Thin HTTP wrapper for the OAuth2 password-grant endpoint.
 * Endpoint, payload shape, and response shape mirror `fb-shipper-frontend`'s
 * `loginUniqueDomain` (POST {baseUrl}/oauth/token).
 */
@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(AUTH_API_CONFIG);

  loginV2(credentials: LoginCredentials): Observable<LoginV2Response> {
    const payload: LoginV2Request = {
      client_id: this.config.clientId,
      client_secret: this.config.clientSecret,
      username: credentials.username,
      password: credentials.password,
      grant_type: 'password',
      scope: '',
      otp: '',
      otp_secret: '',
    };

    return this.http.post<LoginV2Response>(`${this.config.baseUrl}/oauth/token`, payload);
  }
}
